// removed by extract-text-webpack-plugin
module.exports = {"container":"Header-container","walkmeLink":"Header-walkmeLink","rightSide":"Header-rightSide"};